import React, { ReactNode } from "react"
import { Helmet } from "@helpers/Helmet"
import { Header } from "@components/header"
import { Container, FlexBox } from "@components/wrapper"
import clsx from "clsx"

interface FormWrapperProps {
  head: string
  children?: ReactNode
}

const FormWrapper = ({ head, children }: FormWrapperProps) => {
  const executeScroll = (id: string) => () => {
    console.log(id)
    const ele = document.getElementById(id)
    console.log({ ele })

    if (!ele) {
      return
    }

    ele.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <>
      <Helmet title={head} />
      <Header />

      <main className={clsx("sm:pt-30px pb-20", "pt-5 pb-60px")}>
        <h1
          className={clsx(
            "text-center sm:text-1.5xl font-semibold sm:w-2/5 mx-auto sm:mb-6",
            "mb-4 w-full"
          )}
        >
          Lengkapi data diri anda untuk melanjutkan <br /> melamar pekerjaan.
        </h1>
        <Container>
          <div className="mb-3 text-sm">
            <span className="text-red text-base font-semibold">*</span> Semua data wajib di isi
          </div>
          <div className={clsx("sm:py-9 sm:px-8 bg-primary-grey rounded", "pt-18px px-6 pb-60px")}>
            {children}
          </div>
        </Container>
      </main>
    </>
  )
}

const PersonalInfo: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <section {...props}>
      <h2 className="text-md font-semibold">Info Pribadi</h2>
      <hr />
      <FlexBox className={clsx("sm:pt-10 sm:pb-20 sm:gap-8", "gap-6 pb-10")} direction="col">
        {children}
      </FlexBox>
    </section>
  )
}

const OtherQuestion: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <section {...props}>
      <h2 className="text-md font-semibold">Pertanyaan Lainnya</h2>
      <hr />
      <FlexBox className={clsx("sm:pt-10 sm:pb-20 sm:gap-8", "gap-6 pb-10")} direction="col">
        {children}
      </FlexBox>
    </section>
  )
}

FormWrapper.PersonalInfo = PersonalInfo
FormWrapper.OtherQuestion = OtherQuestion

export default FormWrapper
